import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import { url } from 'config/config';
// import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
// import CustomerListTable from 'components/SS/CustomerTable';
import IconifyIcon from 'components/base/IconifyIcon';
// import DashboardMenu from 'components/common/DashboardMenu';
import DataGridPagination from 'components/pagination/DataGridPagination';
import StyledTextField from 'components/styled/StyledTextField';

const Candidate = () => {
  const ViewButton = ({ row }) => {
    const navigate = useNavigate();

    const handleView = () => {
      navigate('/candidate-info', { state: row });
    };

    return (
      <IconButton onClick={handleView}>
        <RemoveRedEyeOutlinedIcon />
      </IconButton>
    );
  };
  const DeleteButton = ({ row }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleConfirmDelete = async () => {
      const res = await post('users/delete_candidate', { id: row._id }); // optional callback
      if (res.status == 200) {
        enqueueSnackbar(res.message, { variant: 'success', autoHideDuration: 3000 });
      } else {
        enqueueSnackbar(res.message, { variant: 'error', autoHideDuration: 3000 });
      }
      handleClose();
      fetchData();
    };

    return (
      <>
        <IconButton color="error" onClick={handleOpen}>
          <DeleteOutlineIcon />
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Confirm Delete</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this record?
              <br />
              This action cannot be undone.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };
  const columns = useMemo(
    () => [
      {
        field: 'view',
        headerName: 'Action',
        sortable: false,
        filterable: false,
        minWidth: 80,
        renderCell: (params) => {
          return (
            <>
              <ViewButton row={params.row} />
              <DeleteButton row={params.row} />
            </>
          );
        },
      },
      {
        field: 'name',
        headerName: 'Candidate',
        minWidth: 280,
        sortable: false,
        filterable: false,
        // flex: 1,
        // valueGetter: ({ name }) => name,
        renderCell: (params) => {
          const { firstName, lastName, profileImage, email } = params.row;

          return (
            <Stack
              sx={{
                gap: 1.5,
                alignItems: 'center',
              }}
            >
              <Avatar
                alt={firstName.toUpperCase()}
                src={profileImage ? `${url}${profileImage}` : ''}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <div>
                <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                  {`${firstName} ${lastName}`}
                </Typography>
                <Link href="#!" variant="caption">
                  {email}
                </Link>
              </div>
            </Stack>
          );
        },
      },
      {
        field: 'qualification',
        headerName: 'Qualification',
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.qualification}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'prevCompany',
        headerName: 'Previous Company',
        minWidth: 250,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.prevCompany}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'prevCTC',
        headerName: 'Previous CTC',
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.prevCTC}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'noticePeriod',
        headerName: 'Notice Period',
        minWidth: 120,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.noticePeriod}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'disqualified',
        headerName: 'Qualified',
        minWidth: 40,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              {params.row.disqualified ? (
                <RemoveCircleIcon fontSize="small" sx={{ color: '#e93a34ff' }} />
              ) : (
                <CheckCircleIcon fontSize="small" sx={{ color: '#41e586ff' }} />
              )}
            </Box>
          );
        },
      },
      // {
      //   field: 'action',
      //   headerName: 'Action',
      //   align: 'right',
      //   width: 60,
      //   headerAlign: 'right',
      //   renderCell: () => <DashboardMenu />,
      // },
    ],
    [],
  );
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
    search: '',
  });
  const [search, setSearch] = useState('');
  const [candidate, setCandidate] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  // const apiRef = useGridApiRef();

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPaginationModel((prev) => {
        return { ...prev, search };
      });
    }, 600);
    return () => clearTimeout(timeOut);
  }, [search]);
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await post('users/list_candidate', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
      });
      if (res.status == 200) {
        setCandidate(res.data.candidate);
        setTotal(res.data.total);
      } else {
        enqueueSnackbar(res.message || 'Error', { variant: 'error' });
        setCandidate([]);
        setTotal(0);
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error', { variant: 'error' });
      setCandidate([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  return (
    <>
      <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <StyledTextField
            id="search-box"
            type="search"
            fullWidth
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search Candidate Name"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              maxWidth: { sm: 200, md: 240 },
              flexGrow: { xs: 1, sm: 0 },
              mb: 3,
            }}
          />
          <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
            <IconifyIcon icon="material-symbols:add-2-rounded" />
            <Box
              component="span"
              sx={{ display: { xs: 'none', sm: 'block' } }}
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(
                    'https://crm.shreesolarsunstar.com/candidate-details',
                  );

                  enqueueSnackbar('Link Copied To Clipboard', {
                    variant: 'success',
                    autoHideDuration: 3000,
                  });
                } catch {
                  enqueueSnackbar('Failed to copy', {
                    variant: 'error',
                    autoHideDuration: 3000,
                  });
                }
              }}
            >
              Candidate Onboard Page
            </Box>
          </Button>
        </Box>
        <Box sx={{ width: '100%' }}>
          <DataGrid
            loading={loading}
            rows={candidate}
            columns={columns}
            getRowId={(row) => row._id}
            pagination
            paginationMode="server"
            rowCount={total}
            paginationModel={paginationModel} // { page: 0, pageSize: 10 }
            onPaginationModelChange={(e) => {
              setPaginationModel(() => ({
                page: e.page,
                pageSize: e.pageSize,
                search: search,
              }));
            }}
            pageSizeOptions={[5, 10, 20]}
            slots={{
              basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
            }}
          />
        </Box>
        {/* <CustomerListTable
          data={customer}
          filterModel={filterModel}
          onFilterModelChange={setFilterMode}
          apiRef={apiRef}
          filterButtonEl={null}
        /> */}
      </Paper>
    </>
  );
};

export default Candidate;
